/**
 * Admin · Distribution overview
 *
 * Buffer-powered multi-platform distribution dashboard was removed
 * 2026-02 alongside the Buffer integration. Pinterest scheduling now
 * lives on the Metricool settings page. This route is kept as a
 * forwarding notice for any bookmarks pointing at /admin/distribution.
 */
import { Link } from "react-router-dom";
import { ChevronLeft, ExternalLink } from "lucide-react";

export default function AdminDistribution() {
    return (
        <div className="min-h-screen bg-bl-bg text-bl px-4 py-6 sm:px-8">
            <div className="max-w-3xl mx-auto space-y-6">
                <Link
                    to="/admin/content"
                    className="inline-flex items-center gap-1 text-xs text-bl-muted hover:text-bl"
                >
                    <ChevronLeft className="h-3 w-3" /> Back to Content Engine
                </Link>
                <div className="bl-card p-6 space-y-4">
                    <h1 className="font-display font-semibold text-2xl tracking-tight">
                        Distribution dashboard moved
                    </h1>
                    <p className="text-sm text-bl-muted">
                        The cross-platform Buffer dashboard was removed.
                        Pinterest scheduling now happens directly from each content
                        package&apos;s <strong className="text-bl">Images</strong> tab
                        and is powered by Metricool.
                    </p>
                    <p className="text-sm text-bl-muted">
                        Configure board mappings + the connected Pinterest profile here:
                    </p>
                    <Link
                        to="/admin/metricool"
                        className="bl-btn-primary text-sm gap-1.5 inline-flex"
                        data-testid="admin-distribution-go-to-metricool"
                    >
                        <ExternalLink className="h-3.5 w-3.5" /> Open Metricool Settings
                    </Link>
                </div>
            </div>
        </div>
    );
}
